module.exports = new __parcel__URL__("lightning.44c03a60.svg").toString();